import React, { useState } from "react";
import { Field, Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { Switch } from "../../../components/inputs/final_form/Switch";
import { LoadingButton } from "../../../components/LoadingButton";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const AddLabsModal = ({ clinicId, onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleAdd = async (params) => {
    setError(null);

    try {
      const labId = params.labId;
      const createParams = { clinicId, labId, ...params };

      const { data } = await api.post(`/admin/clinic_lab_permissions/`, snakifyKeys(createParams));

      if (onAdd) {
        onAdd(data.meta.message);
      }

      setOpen(false);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Labs
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Labs</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleAdd}>
            {({ handleSubmit, submitting }) => {
              return (
                <>
                  <Field component={AdminOptionableInput} resource="labs" label="Labs" name="labId" required isMulti />
                  <Field component={Switch} label="Add all Labs" name="addAllLabs" id="add-all-labs" type="checkbox" />
                  <Field component={Switch} label="Reflex to PA" name="reflexToPa" id="reflex-to-pa" type="checkbox" />
                  <Field component={Switch} label="Use Lab Pricing" name="useLabPricing" id="use-lab-pricing" type="checkbox" />

                  <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
                    Submit
                  </LoadingButton>
                </>
              );
            }}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
